export default "__VITE_ASSET__CXjburKg__"